import { NavLink } from 'react-router-dom';

const GreetingsSection = ({ project, id }) => (
  <div className="d-flex justify-content-between">
    <div className="fs-5 fw-bold mt-2 mb-4">Greetings</div>
    <div>
      <NavLink
        to={{
          pathname: `/project/update-note/${project?.projectInformatin?.orderNo}/${id}`,
        }}
        className="btn btn-fill fw-bold"
        state={{ noted: project?.roomInformation?.noted }}
        exact="true"
      >
        Update Greetings
      </NavLink>
    </div>
  </div>
);

const GreetingsTable = ({ project }) => (
  <table>
    <tbody>
      <tr className="align-top">
        <td width="150">
          <p className="fz-14 ff2">Greetings</p>
        </td>
        <td>
          <p className="fz-14 fw-bold">
            {project?.roomInformation?.noted ||
              'You haven’t updated your greeting note.'}
          </p>
        </td>
      </tr>
    </tbody>
  </table>
);

const DesignConceptSection = ({ designPlans, handleAddNewDesign }) => (
  <div className="d-flex justify-content-between">
    <div className="fs-5 fw-bold mt-2 mb-4">Design Concept</div>
    {designPlans?.find((dPlan) => dPlan?.status === 'Final Design') ===
      undefined &&
      ((designPlans?.filter((dPlan) => dPlan?.OnSubmit === false).length !==
        0 &&
        designPlans?.length !== 0) ||
        designPlans?.length === 0) && (
        <div>
          <button onClick={handleAddNewDesign} className="btn btn-fill fw-bold">
            Add New Design
          </button>
        </div>
      )}
  </div>
);

const DesignConceptInfo = () => (
  <div className="w-100 mb-4 alert alert-basic" role="alert">
    <p className="fz-14 fw-bolder">Info:</p>
    <p className="mb-2 fz-14">
      1. Add new design and pick the design concept you want to submit.
    </p>
    <p className="mb-2 fz-14">
      2. The file that you send in this submission will be received by the
      customer after all design concepts in each room are submitted.
    </p>
  </div>
);

const DesignPlanCard = ({
  designPlan,
  designPlanCheckboxes,
  handleDesignPlanCheckboxes,
  project,
  id,
}) => (
  <div className="card card-project">
    <div className="card-body p-5">
      <div className="row item">
        <div className="col-12 col-md-1 d-flex align-items-center">
          {designPlan?.onSubmit === false &&
            designPlanCheckboxes.find(
              (dPlan) => dPlan?.designChoose === true
            ) === undefined && (
              <input
                className="form-check-input me-3"
                type="checkbox"
                value={designPlan.id}
                style={{
                  width: '30px',
                  height: '30px',
                  border: '3px solid black',
                }}
                checked={designPlanCheckboxes.includes(`${designPlan.id}`)}
                onChange={(e) => {
                  if (e.target.checked) {
                    handleDesignPlanCheckboxes([
                      ...designPlanCheckboxes,
                      e.target.value,
                    ]);
                  } else {
                    handleDesignPlanCheckboxes(
                      designPlanCheckboxes.filter(
                        (item) => item !== e.target.value
                      )
                    );
                  }
                }}
              />
            )}
        </div>
        <div className="col-12 col-md-5 content-image">
          <div className="d-flex justify-content-around align-items-start">
            <div className="design-plan__picture">
              <img
                src={
                  designPlan.photos[0]?.full_image_url ||
                  '/dist/img/empty/empty-product.png'
                }
                alt="item"
                loading="lazy"
              />
            </div>
            <div className="design-plan__info-1 ms-4">
              <dl>
                <dt>TITLE</dt>
                <dd>
                  <span className="fs-5 fw-bold">
                    {designPlan.title.length > 10
                      ? designPlan.title.substring(0, 10) + '...'
                      : designPlan.title}
                  </span>
                </dd>
              </dl>
              <NavLink
                to={`/project/detail-design/${project?.projectInformatin?.orderNo}/${designPlan.id}/${id}`}
                className="badge-yellow"
              >
                View
              </NavLink>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="row row-cols-2 px-5">
            <dl className="col mb-0">
              <dt>LAST UPDATE</dt>
              <dd>{designPlan.lastUpdate}</dd>
              <dt>STATUS</dt>
              <dd>
                <div className="badge-new badge-gray">{designPlan.status}</div>
              </dd>
            </dl>
            <dl className="col mb-0">
              <dt>CLIENT BUDGET</dt>
              <dd>Rp {designPlan.clientBudget}</dd>
              {designPlan?.designChoose === true && (
                <dd>
                  <div
                    className="badge-new badge-gray"
                    style={{ marginTop: '73px' }}
                  >
                    <strong>Selected Design</strong>
                  </div>
                </dd>
              )}
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const DesignPlanList = ({
  designPlans,
  designPlanCheckboxes,
  handleDesignPlanCheckboxes,
  project,
  id,
}) => (
  <div className="design-plan-list">
    {designPlans.map((designPlan, index) => (
      <DesignPlanCard
        key={index}
        designPlan={designPlan}
        designPlanCheckboxes={designPlanCheckboxes}
        handleDesignPlanCheckboxes={handleDesignPlanCheckboxes}
        project={project}
        id={id}
      />
    ))}
  </div>
);

const TabDesignPlans = ({
  designPlans,
  designPlanCheckboxes,
  handleAddNewDesign,
  handleDesignPlanCheckboxes,
  id,
  tab,
  project,
}) => {
  const isDesignSelected = designPlans?.find(
    (dPlan) => dPlan?.designChoose === true
  );

  return (
    <div
      className={`tab-pane fade ${tab === 'designPlan' ? 'show active' : ''}`}
      id="dplans-temp"
      role="tabpanel"
      aria-labelledby="dplans-tab"
    >
      <GreetingsSection project={project} id={id} />
      <GreetingsTable project={project} />
      <hr className="mt-5 mb-5" />
      <DesignConceptSection
        designPlans={designPlans}
        handleAddNewDesign={handleAddNewDesign}
      />
      <DesignConceptInfo />
      {designPlans && designPlans.length > 0 ? (
        <>
          <DesignPlanList
            designPlans={designPlans}
            designPlanCheckboxes={designPlanCheckboxes}
            handleDesignPlanCheckboxes={handleDesignPlanCheckboxes}
            project={project}
            id={id}
          />
          {!isDesignSelected && (
            <div className="text-right">
              <button
                className="btn btn-fill fw-bold"
                disabled={designPlanCheckboxes.length === 0}
                data-bs-toggle="modal"
                data-bs-target="#modalSubmitDesign"
              >
                Submit Design Concept
              </button>
            </div>
          )}
        </>
      ) : (
        <div
          className="d-flex flex-column align-items-center h-100"
          style={{ marginTop: '75px' }}
        >
          <div className="img-wrap" style={{ width: '300px', height: '300px' }}>
            <img
              src="/dist/img/empty/empty-product.png"
              alt="item-empty"
              loading="lazy"
            />
          </div>
          <div className="d-flex align-items-center justify-content-center mt-3 fw-bold">
            You haven't created your design concept yet.
          </div>
        </div>
      )}
    </div>
  );
};

export default TabDesignPlans;
